import LinkButton from './link-button';
import { LinkButtonTypes } from './types';

import './link-button.css';

export default function LinkSecondaryButton({
  className,
  text = '',
  disabled,
  icon,
  onClick,
  path,
  backPath,
  target,
}: LinkButtonTypes): React.JSX.Element {
  return (
    <LinkButton
      path={path}
      className={`${className || ''} secondary`}
      text={text}
      disabled={disabled}
      icon={icon}
      onClick={onClick}
      backPath={backPath}
      target={target}
    />
  );
}
